import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from 'config/firebase';

const AccessDenied = () => (
  <main id="main-content" style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '50vh',
    padding: '2rem',
    textAlign: 'center'
  }}>
    <h2 style={{ marginBottom: '1rem', color: 'var(--text-primary)' }}>Access Denied</h2>
    <p style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)' }}>
      You do not have permission to access this page.
    </p>
    <a href="/" style={{
      padding: '0.75rem 1.5rem',
      backgroundColor: 'var(--color-bg-inverse)',
      color: 'var(--color-ink-inverse)',
      textDecoration: 'none',
      borderRadius: 'var(--radius-md)'
    }}>
      Go Home
    </a>
  </main>
);

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingAdmin, setCheckingAdmin] = useState(requireAdmin);

  useEffect(() => {
    if (!requireAdmin || !currentUser) {
      setCheckingAdmin(false);
      return;
    }

    const checkAdmin = async () => {
      try {
        const adminDoc = await getDoc(doc(db, 'admins', currentUser.uid));
        setIsAdmin(adminDoc.exists());
      } catch {
        setIsAdmin(false);
      } finally {
        setCheckingAdmin(false);
      }
    };

    checkAdmin();
  }, [currentUser, requireAdmin]);

  if (authLoading || checkingAdmin) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        color: 'var(--text-secondary)'
      }}>
        Loading...
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
